import React, { Fragment } from 'react';
import './HomeGames.css';
import AdComponent from '../AdComponent/AdComponent';
import { FaCoins, FaUsers } from 'react-icons/fa';

function HomeGames({ onPlay }) {
    let data = [
        {
            "id": 2,
            "title": "2048",
            "shortUrl": "2048",
            "logo": "2048.webp",
            "banner": "2048.webp",
            "users": "30k"
        },
        {
            "id": 6,
            "title": "Foono Online Multiplayer",
            "shortUrl": "foono-online-multiplayer",
            "logo": "Foono-Online-Multiplayer.webp",
            "banner": "Foono-Online-Multiplayer.webp",
            "users": "25k"
        },
        {
            "id": 9,
            "title": "Wood Block Journey",
            "shortUrl": "wood-block-journey",
            "logo": "Wood-Block-Journey.webp",
            "banner": "Wood-Block-Journey.webp",
            "users": "12k"
        },
        {
            "id": 4,
            "title": "Hyper Jump 3D",
            "shortUrl": "hyper-jump-3d",
            "logo": "hyper-jump-3d.webp",
            "banner": "hyper-jump-3d.webp",
            "users": "17k"
        },
        {
            "id": 84,
            "title": "Hextris",
            "shortUrl": "hextris",
            "logo": "Hextris.webp",
            "banner": "Hextris.webp",
            "users": "19k"
        },
        {
            "id": 16,
            "title": "Racing Limits",
            "shortUrl": "racing-limits",
            "logo": "Racing-Limits.webp",
            "banner": "Racing-Limits.webp",
            "users": "22k"
        },
        {
            "id": 19,
            "title": "Car Clash 2",
            "shortUrl": "car-clash-2",
            "logo": "Car-Clash-2.webp",
            "banner": "Car-Clash-2.webp",
            "users": "23k"
        },
        {
            "id": 55,
            "title": "Bubble Blast",
            "shortUrl": "bubble-blast",
            "logo": "Bubble Blast.webp",
            "banner": "Bubble Blast.webp",
            "users": "30k"
        },
        {
            "id": 21,
            "title": "Crazy Drift",
            "shortUrl": "crazy-drift",
            "logo": "Crazy-Drift.webp",
            "banner": "Crazy-Drift.webp",
            "users": "22k"
        },
        {
            "id": 28,
            "title": "Xtreme DRIFT Racing",
            "shortUrl": "xtreme-drift-racing",
            "logo": "Xtreme-DRIFT-Racing.webp",
            "banner": "Xtreme-DRIFT-Racing.webp",
            "users": "33k"
        }
    ]


    return (
        <>
            <div className='row m-0 g-3'>
                {
                    data.map((game, index) => {
                        return <Fragment key={index}>
                            {/* {index == 4 &&
                                <div className='col-12'>
                                    <AdComponent
                                        client="ca-pub-2248973218739803"
                                        slot="3776487389"
                                        format="auto"
                                        style={{ display: 'block', width: '100%', height: '250px' }}
                                    />
                                </div>
                            } */}
                            <div className="game-col">
                                <div
                                    className="card gameCard h-100"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => onPlay(`https://www.playpokigames.com/game/${game.shortUrl}`)}
                                >
                                    <img src={require(`../../assets/images/${game.logo}`)} alt={"Play poki games - " + game.title} />
                                    <div className="card-body p-2 text-center">
                                        <p className='m-0 game-title-card'>{game.title}</p>
                                        <div className='game-info-row mt-1'>
                                            <span className='entry-fee-text'>Entry: 10 <FaCoins className='ms-1 text-warning' /></span>
                                        </div>
                                        <div className='game-users-row mt-1'>
                                            <span className='users-playing-text'><FaUsers className='me-1' /> {game.users} playing</span>
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        <button className='game-play-btn'>PLAY</button>
                                    </div>
                                </div>
                            </div>
                        </Fragment>
                    })
                }
            </div>
        </>
    )
}

export default HomeGames